'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';
import logHelper from 'com-gyf-webcore-loghelper/Content/App/Packages/LogHelper/LogHelper';

/**
 * Importación de las Actions.
 */
import {
    GET_DATA_VISTA_INSTANCIA_PARAMETROS,
    GET_DATA_VISTA_INSTANCIA_PARAMETROS_DATA,
    RESET_STATE_VISTA_INSTANCIA_PARAMETROS,
    GET_DATA_VISTA_INSTANCIA_PARAMETROS_PAGINADO,
    LOADING_ATLAS,
    SELECT_COMBO,
    SELECT_RADIO,
    ELIMINAR_FILTRO,
    UPDATE_INPUT_FILTRO,
    GET_ENTIDAD_RELACIONADA,
    LIMPIAR_FILTROS,
    MOSTRAR_FILTROS,
    ERROR_FILTROS,
    CAMBIAR_FILTRO_ACTIVO,
    CARGAR_FILTROS_DEFINITIVOS,
    ERROR_VALIDACION_FORMATO_FILTRO
} from '../../Screens/VistaInstanciaParametro/actions/Actions';

/**
 * Estado inicial.
 */
const initialState = {
    data: {
        loading: false,
        entidad: undefined,
        cantidadRegistrosEntidad: undefined,
        cantidadRegistrosParaPaginar: undefined,
        cantidadRegistrosPropiedadInstancia: undefined,
        propiedadInstancia: undefined,
        entidadInstancia: undefined,
        registrosActualesEnPagina: undefined,
        cantidadPaginas: undefined,
        paginaActual: 0,
        ultimoRegistro: undefined,
        indicePaginas: [],
        indices: undefined,
        instancias: [],
        propiedadesVisibleEnGrilla: [],
        criterioDeBusqueda: {
            propiedadId: -1,
            instanciasCombo: [],
        },
        arrayFiltros: [],
        arrayFiltrosDefinitivo: [],
        optionsEntidadRelacionadas: [],
        mostrarFiltros: false,
        //Flag utilizado para determinar si los filtros seleccionados están siendo utilizados (identificado a través del click en el botón "Ver")
        //De esta forma, cada búsqueda realizada a la BD se determina si los filtros agregados deben ser contemplados o no
        filtrosActivos: false,
        instanciasComboInicial: []
    }
};

/**
 * Reduce store.
 */
let result;

function vistaInstanciaParametro(state = initialState, action) {
    LogHelper.In(vistaInstanciaParametro.name, state, action);

    switch (action.type) {

        case GET_DATA_VISTA_INSTANCIA_PARAMETROS:
            LogHelper.In(vistaInstanciaParametro.name, state, action);

            result = {
                data: {
                    ...state.data,
                    loading: true
                }
            };
            break;

        case UPDATE_INPUT_FILTRO:
            LogHelper.In(vistaInstanciaParametro.name, state, action);

            let arrayFiltrosInputAux = state.data.arrayFiltros;

            arrayFiltrosInputAux.map(input => {
                if (input.instancia.Codigo == action.codigo) {
                    input.valorInput = action.valor;
                    input.error = false;
                    input.errorFormato = false;
                    input.errorFechaInvalida = false;
                }
            });

            result = {
                data: {
                    ...state.data,
                    arrayFiltros: arrayFiltrosInputAux
                }
            };

            break;

        case GET_ENTIDAD_RELACIONADA:
            LogHelper.In(vistaInstanciaParametro.name, state, action);

            let objEntidadRelacionadas = { entidadRelacionadas: [], entidadId: null };
            let arrayOptionsEntidadRelacionadas = [];
            let instanciasConEntidades = action.dataInstanciaParametro.instancias;

            instanciasConEntidades.map(ins => {
                if (ins.entidadRelacionada) {
                    //Se obtienen todas las opciones de entidades relacionadas para poblar el combo de "Valor de búsqueda"
                    //y así tener la posibilidad de buscar cualquier valor para cualquier registro
                    //objEntidadRelacionadas.entidadRelacionadas = ins.entidadRelacionada.filter(x => x.ACTIVO);
                    objEntidadRelacionadas.entidadRelacionadas = ins.entidadRelacionada;
                    objEntidadRelacionadas.entidadId = ins.EntidadRelacionadaId;

                    arrayOptionsEntidadRelacionadas.push(objEntidadRelacionadas);

                    objEntidadRelacionadas = { entidadRelacionadas: [], entidadId: null };
                }
            });

            let options = [];

            arrayOptionsEntidadRelacionadas?.length > 0 && arrayOptionsEntidadRelacionadas.forEach((arr) => {
                let objOption = { Id: "", Descripcion: "", Codigo: "", EntidadId: "" };
                let EntidadId = arr.entidadId;

                arr?.entidadRelacionadas?.length > 0 && arr.entidadRelacionadas.map((er) => {

                    objOption.Id = er.Codigo == "ID" ? er.Valor : objOption.Id;
                    objOption.Descripcion = er.Codigo == "DESCRIPCION" ? er.Valor : objOption.Descripcion;
                    objOption.Codigo = er.Codigo == "CODIGO" ? er.Valor : objOption.Codigo;
                    objOption.EntidadId = EntidadId;

                    if (objOption.Id && objOption.Descripcion && objOption.Codigo) {
                        options.push(objOption);
                        objOption = { Id: "", Descripcion: "", Codigo: "", EntidadId: "" };
                    }
                });
            })

            result = {
                data: {
                    ...state.data,
                    optionsEntidadRelacionadas: options
                }
            };

            break;

        case SELECT_RADIO:
            LogHelper.In(vistaInstanciaParametro.name, state, action);

            let arrayFiltrosAux = state.data.arrayFiltros;
            arrayFiltrosAux.valorRadioButton = action.valor;

            arrayFiltrosAux.map(rd => {
                if (rd.propiedadId == action.propiedadId) {
                    rd.valorRadioButton = action.valor;
                }
            });

            result = {
                data: {
                    ...state.data,
                    arrayFiltros: arrayFiltrosAux
                }
            };

            break;

        case ELIMINAR_FILTRO:
            LogHelper.In(vistaInstanciaParametro.name, state, action);

            let arrFiltrosAux = state.data.arrayFiltros;
            let indexFiltroSeleccionado = state.data.arrayFiltros.findIndex(filtro => filtro.propiedadId == action.id);
            let objFiltroAux = arrFiltrosAux.splice(indexFiltroSeleccionado, 1);
            let instanciasComboAux = state.data.criterioDeBusqueda.instanciasCombo;

            if (objFiltroAux?.length == 1) {
                instanciasComboAux.push(objFiltroAux[0].instancia);
            }

            result = {
                data: {
                    ...state.data,
                    criterioDeBusqueda: {
                        ...state.data.criterioDeBusqueda,
                        instanciasCombo: instanciasComboAux
                    },
                    arrayFiltros: arrFiltrosAux
                }
            };

            break;

        case SELECT_COMBO:
            LogHelper.In(vistaInstanciaParametro.name, state, action);

            if (action.campo == "nuevoFiltro") {

                let instanciasAux = state.data.criterioDeBusqueda.instanciasCombo;
                let optionsEntidadRelacionadasAux = state.data.optionsEntidadRelacionadas;
                let arrayFiltrosAux = [];
                let objFiltro = { valorRadioButton: "P", options: [], optionSeleccionado: -1, propiedadId: null, valorBusqueda: null, instancia: [] };

                objFiltro.valorRadioButton = "P";
                objFiltro.propiedadId = instanciasAux[action.index - 1].PropiedadId;
                objFiltro.valorBusqueda = "";
                objFiltro.instancia = instanciasAux.splice(action.index - 1, 1)[0];
                objFiltro.options = [];

                optionsEntidadRelacionadasAux?.length > 0 && optionsEntidadRelacionadasAux.map((op) => {
                    if (op.EntidadId == objFiltro.instancia.EntidadRelacionadaId)
                        objFiltro.options.push(op);
                });

                arrayFiltrosAux.push(objFiltro);

                result = {
                    data: {
                        ...state.data,
                        criterioDeBusqueda: {
                            ...state.criterioDeBusqueda,
                            propiedadId: action.id,
                            instanciasCombo: instanciasAux
                        },
                        arrayFiltros: [...state.data.arrayFiltros, objFiltro]
                    }
                };
            }

            if (action.campo == "Filtro") {

                let arrayFiltrosAux = state.data.arrayFiltros;

                arrayFiltrosAux.map((arr) => {
                    if (arr.propiedadId == action.index) {
                        arr.optionSeleccionado = action.id;
                        arr.error = false;
                        arr.errorFormato = false;
                        arr.errorFechaInvalida = false;
                    }
                });

                result = {
                    data: {
                        ...state.data,
                        arrayFiltros: arrayFiltrosAux
                    }
                };
            }

            if (action.campo == "check") {

                let arrayFiltrosAux = state.data.arrayFiltros;

                arrayFiltrosAux.map((arr) => {
                    if (arr.propiedadId == action.index) {
                        arr.optionSeleccionado = action.id;
                        arr.error = false;
                        arr.errorFormato = false;
                        arr.errorFechaInvalida = false;
                    }
                });

                result = {
                    data: {
                        ...state.data,
                        arrayFiltros: arrayFiltrosAux
                    }
                };
            }

            break;

        case LOADING_ATLAS:
            LogHelper.In(vistaInstanciaParametro.name, state, action);

            result = {
                data: {
                    ...state.data,
                    loading: action.valor
                }
            };
            break;

        case GET_DATA_VISTA_INSTANCIA_PARAMETROS_DATA:
            LogHelper.In(vistaInstanciaParametro.name, state, action);

            result = {
                ...state,
                data: {
                    ...state.data,
                    loading: false,
                    entidad: action.dataCompleto.entidad,
                    cantidadRegistrosEntidad: action.dataCompleto.cantidadRegistrosEntidad,
                    cantidadRegistrosParaPaginar: action.dataCompleto.cantidadRegistrosParaPaginar,
                    cantidadRegistrosPropiedadInstancia: action.dataCompleto.cantidadRegistrosPropiedadInstancia,
                    propiedadInstancia: action.dataCompleto.propiedadInstancia,
                    entidadInstancia: action.dataCompleto.entidadInstancia,
                    registrosActualesEnPagina: 100,
                    cantidadPaginas: action.dataCompleto.cantidadPaginas,
                    paginaActual: action.dataCompleto.paginaActual,
                    indiceFinalPaginas: action.indicePaginas,
                    instancias: action.dataCompleto.instancias,
                    propiedadesVisibleEnGrilla: action.dataCompleto.propiedadesVisibleEnGrilla,
                    criterioDeBusqueda: {
                        ...state.data.criterioDeBusqueda,
                        instanciasCombo: state?.data?.criterioDeBusqueda?.instanciasCombo?.length > 0 ?
                            state.data.criterioDeBusqueda.instanciasCombo : action.dataCompleto.propiedadesVisibles
                    },
                    instanciasComboInicial: action.dataCompleto.comboInicial
                }
            };
            break;

        case GET_DATA_VISTA_INSTANCIA_PARAMETROS_PAGINADO:
            LogHelper.In(vistaInstanciaParametro.name, state, action);

            result = {
                ...state,
                data: {
                    ...state.data,
                    loading: false,
                    propiedadInstancia: action.dataCompletoPag.propiedadInstancia,
                    paginaActual: action.llamadaDesdeInput ? action.llamadaDesdeInput : state.paginaActual
                }
            };
            break;

        case LIMPIAR_FILTROS:
            LogHelper.In(vistaInstanciaParametro.name, state, action);

            result = {
                data: {
                    ...state.data,
                    criterioDeBusqueda: {
                        ...state.data.criterioDeBusqueda,
                        instanciasCombo: action.arrayInicial,
                        propiedadId: -1,
                    },
                    mostrarFiltros: false,
                    arrayFiltros: [],
                    arrayFiltrosDefinitivo: []
                }
            };
            break;

        case ERROR_FILTROS:
            LogHelper.In(vistaInstanciaParametro.name, state, action);

            let arrFiltros = state.data.arrayFiltros;

            if (action.arrayError) {
                arrFiltros.map((a, i) => {
                    if (action.arrayError.includes(i)) {
                        a.error = true;
                    }
                });
            } else {
                arrFiltros.map((a) => {
                    a.error = false;
                });
            }

            result = {
                data: {
                    ...state.data,
                    arrayFiltros: arrFiltros
                }
            };
            break;

        case MOSTRAR_FILTROS:
            LogHelper.In(vistaInstanciaParametro.name, state, action);

            result = {
                data: {
                    ...state.data,
                    mostrarFiltros: action.valor
                }
            };
            break;

        case RESET_STATE_VISTA_INSTANCIA_PARAMETROS:
            LogHelper.In(vistaInstanciaParametro.name, state, action);

            result = Object.assign({}, initialState);
            result = {
                data: {
                    ...state.data,
                    criterioDeBusqueda: {
                        propiedadId: -1,
                        instanciasCombo: [],
                    },
                    arrayFiltros: [],
                    arrayFiltrosDefinitivo: [],
                    mostrarFiltros: false,
                    filtrosActivos: false
                }
            };
            break;
        
        case CAMBIAR_FILTRO_ACTIVO:
            LogHelper.In(vistaInstanciaParametro.name, state, action);

            result = {
                data: {
                    ...state.data,
                    filtrosActivos: action.filtrosActivos
                }
            };
            break;

        case CARGAR_FILTROS_DEFINITIVOS:
            LogHelper.In(vistaInstanciaParametro.name, state, action);

            result = {
                data: {
                    ...state.data,
                    arrayFiltrosDefinitivo: action.array
                }
            };
            break;
        
        case ERROR_VALIDACION_FORMATO_FILTRO:
            LogHelper.In(vistaInstanciaParametro.name, state, action);

            let arrayFiltrosValidado = state.data.arrayFiltros;

            arrayFiltrosValidado.map((filtro) => {
                if (filtro.propiedadId == action.propiedadId) {
                    filtro.errorFormato = action.esError;
                    filtro.errorFechaInvalida = action.esFechaInvalida;
                }
            });

            result = {
                data: {
                    ...state.data,
                    arrayFiltros: arrayFiltrosValidado
                }
            };
            break;
            

        default: {
            LogHelper.In(vistaInstanciaParametro.name, state, action);

            result = state;
            break;
        }
    }

    LogHelper.Out(vistaInstanciaParametro.name, result);
    return result;
}

export default vistaInstanciaParametro;